import { isNil } from 'lodash';
import React, { useEffect } from 'react';
import CableStatusComponent from './CableStatusComponent';
import OnlineStatusComponent from './OnlineStatusComponent';
import SessionStatusComponent from './SessionStatusComponent';
import { StateColumnInner } from './styles';
import { demoMetricsKeys } from '../../Demo/data';

function CurrentlyComponent(props) {
  const {
    chargerId,
    stateChargerId,
    snapshot: { onlineStatus = 'offline', onlineStatusAt, cableStatus = 'disconnected', cableStatusAt, session } = {},
    load,
    demo,
    snapshotLoading,
    resetChargerTelemetryState,
    updateInterval,
  } = props;

  const sessionWithoutDemoMetricsKeys =
    session &&
    Object.keys(session)
      .filter((key) => !Object.keys(demoMetricsKeys).includes(key))
      .reduce(
        (acc, key) =>
          (acc[key] = {
            ...acc,
            [key]: session[key],
          }),
        {},
      );
  const values = demo ? sessionWithoutDemoMetricsKeys : session;

  useEffect(() => {
    if (isNil(stateChargerId) || stateChargerId !== chargerId) {
      resetChargerTelemetryState();
      load();
    }
    if (!demo) {
      const interval = setInterval(load, updateInterval * 1000);

      return () => clearInterval(interval);
    }
  }, []);

  return (
    <StateColumnInner>
      <OnlineStatusComponent status={onlineStatus} statusAt={onlineStatusAt} snapshotLoading={snapshotLoading} />
      <CableStatusComponent status={cableStatus} statusAt={cableStatusAt} />
      <SessionStatusComponent values={values} />
    </StateColumnInner>
  );
}

export default CurrentlyComponent;
